/*
  RawFella Fit Advisor - Shopify Fabric version
  Put this file in: Assets/fit-advisor-widget.js
*/
(function () {
  var OLD_PROFILE_KEY = "rawfella_fit_profile_v1";
  var SIZE_KEY = "rawfella_fit_last_size_v2";

  var DEFAULT_CHART = [
    { size: "S", chest: [99, 104], waist: [94, 99], length: [66, 69], unit: "cm" },
    { size: "M", chest: [107, 112], waist: [102, 107], length: [69, 71], unit: "cm" },
    { size: "L", chest: [114, 119], waist: [109, 114], length: [71, 74], unit: "cm" },
    { size: "XL", chest: [122, 127], waist: [117, 122], length: [74, 76], unit: "cm" },
    { size: "2XL", chest: [128, 134], waist: [123, 130], length: [76, 79], unit: "cm" }
  ];

  var FIT_EASE = {
    fitted: { chest: 5, waist: 3.5, shoulder: 3.2, length: -0.2, label: "fitted" },
    regular: { chest: 7, waist: 5, shoulder: 4.1, length: 0.1, label: "regular" },
    loose: { chest: 9.5, waist: 7, shoulder: 5, length: 0.45, label: "loose" }
  };

  var BODY = {
    lean: { chest: -1.2, waist: -1.4 },
    average: { chest: 0, waist: 0 },
    athletic: { chest: 1.8, waist: -0.4 },
    broad: { chest: 2.6, waist: 0.6 },
    full: { chest: 1.8, waist: 2.3 }
  };

  var STRUCTURE = {
    narrow: { chest: -0.8, length: 0, note: "narrow shoulders" },
    balanced: { chest: 0, length: 0, note: "balanced shoulders" },
    broad: { chest: 1.4, length: 0, note: "broad shoulders" }
  };

  var QUESTION_STEPS = 4;
  var RESULT_STEP = 4;

  function init() {
    injectStyles();

    var mount = document.querySelector("[data-fit-advisor]");
    if (!mount) return;

    var productRoot = mount.closest("[data-product-fit]") || document.body;
    var metafieldChart = readChart();
    var product = {
      id: productRoot.getAttribute("data-product-id") || window.location.pathname,
      title: productRoot.getAttribute("data-product-title") || document.querySelector("h1")?.textContent || "this item",
      image: productRoot.getAttribute("data-product-image") || findProductImage(productRoot),
      chart: metafieldChart || normalizeChart(DEFAULT_CHART)
    };
    clearOldProfile();

    var state = {
      open: false,
      step: 0,
      profile: normalizeProfile(null)
    };

    function render() {
      document.body.classList.toggle("fit-advisor-modal-open", state.open);
      removeModal();
      mount.innerHTML = launcherHtml(state);

      if (state.open) document.body.insertAdjacentHTML("beforeend", modalHtml(product, state));

      bind(mount, product, state, render);
      moveIntoSizing(mount);
      selectLastRecommendedSize(product);
    }

    render();
    retryMove(mount);
  }

  function readChart() {
    var node = document.querySelector("#fit-size-data");
    if (!node) return null;

    try {
      var parsed = JSON.parse(node.textContent.trim());
      if (typeof parsed === "string") parsed = JSON.parse(parsed);
      if (parsed && typeof parsed.value === "string") parsed = JSON.parse(parsed.value);

      var chart = Array.isArray(parsed) ? parsed : parsed.sizes || parsed.chart;
      return normalizeChart(chart);
    } catch (error) {
      return null;
    }
  }

  function normalizeChart(chart) {
    if (!Array.isArray(chart)) return null;

    return chart
      .map(function (item) {
        var unit = item.unit || item.units || "";
        var chest = normalizeRange(item.chest || item.bust || item.width, unit, "chest");
        return {
          size: String(item.size || "").toUpperCase(),
          height: normalizeHeightRange(item.height || item.height_range || item.recommended_height || item.customer_height, unit),
          chest: chest.range,
          chestWasHalf: chest.wasHalf,
          shoulder: normalizeRange(item.shoulder || item.shoulders, unit, "shoulder").range,
          waist: normalizeRange(item.waist, unit, "waist").range,
          length: normalizeRange(item.length || item.body_length, unit, "length").range,
          sleeve: normalizeRange(item.sleeve_length || item.sleeve || item["sleeve length"], unit, "sleeve").range
        };
      })
      .filter(function (item) {
        return item.size;
      });
  }

  function normalizeRange(value, unit, measurement) {
    if (!value) return { range: null, wasHalf: false };
    var matches = String(value).match(/\d+(\.\d+)?/g) || [];
    var range = Array.isArray(value) ? value.map(Number) : matches.map(Number);
    if (!range.length) return { range: null, wasHalf: false };
    var singleValue = range.length === 1;
    if (singleValue) range.push(range[0]);

    var min = Math.min(range[0], range[1]);
    var max = Math.max(range[0], range[1]);
    if (unit === "cm" || max > 65) {
      min = min / 2.54;
      max = max / 2.54;
    }

    // Chest is supplied as a flat PIT-TO-PIT HALF measurement.
    // Double it deterministically to a full garment circumference.
    var wasHalf = false;
    if (measurement === "chest" && max > 0 && max < 34) {
      wasHalf = true;
      min = min * 2;
      max = max * 2;
    }

    if (singleValue) {
      var tolerance = singleValueTolerance(measurement);
      min = min - tolerance;
      max = max + tolerance;
    }

    return { range: [min, max], wasHalf: wasHalf };
  }

  function singleValueTolerance(measurement) {
    if (measurement === "chest") return 0.85;
    if (measurement === "shoulder") return 0.28;
    if (measurement === "length") return 0.45;
    if (measurement === "waist") return 0.85;
    if (measurement === "sleeve") return 0.25;
    return 0.4;
  }

  function normalizeHeightRange(value, unit) {
    if (!value) return null;

    var heights = [];
    if (Array.isArray(value)) {
      value.forEach(function (item) {
        heights = heights.concat(extractHeights(item, unit));
      });
    } else {
      heights = extractHeights(value, unit);
    }

    heights = heights
      .filter(function (height) {
        return Number.isFinite(height) && height > 36 && height < 96;
      })
      .filter(function (height, index, array) {
        return array.indexOf(height) === index;
      });

    if (!heights.length) return null;
    if (heights.length === 1) heights.push(heights[0]);

    return [Math.min.apply(Math, heights), Math.max.apply(Math, heights)];
  }

  function extractHeights(value, unit) {
    if (typeof value === "number") return [normalizeHeightNumber(value, unit)];

    var text = String(value)
      .replace(/[’‘]/g, "'")
      .replace(/[“”″]/g, '"')
      .replace(/[–—]/g, "-")
      .toLowerCase();
    var heights = [];

    var rangeStart = text.match(/^\s*(\d+)\s*(?:-|to)\s*\d+\s*'/);
    if (rangeStart) heights.push(Number(rangeStart[1]) * 12);

    text.replace(/(\d+)\s*'\s*(\d{1,2})?/g, function (_, feet, inches) {
      heights.push(Number(feet) * 12 + Number(inches || 0));
    });

    text.replace(/(\d+)\s*ft\s*(\d{1,2})?/g, function (_, feet, inches) {
      heights.push(Number(feet) * 12 + Number(inches || 0));
    });

    if (!heights.length) {
      var numbers = text.match(/\d+(\.\d+)?/g) || [];
      heights = numbers.map(function (number) {
        return normalizeHeightNumber(Number(number), text.indexOf("cm") !== -1 ? "cm" : unit);
      });
    }

    return heights;
  }

  function normalizeHeightNumber(value, unit) {
    if (unit === "cm" || value > 90) return value / 2.54;
    if (value >= 36) return value;
    if (value >= 4 && value <= 8) return value * 12;
    return value;
  }

  function launcherHtml(state) {
    return [
      '<div class="fit-advisor__launcher">',
      '  <p class="fit-advisor__eyebrow">FIT FINDER</p>',
      '  <button type="button" data-fit-open>FIND MY SIZE</button>',
      "</div>"
    ].join("");
  }

  function modalHtml(product, state) {
    var progress = state.step >= RESULT_STEP ? 100 : ((state.step + 1) / QUESTION_STEPS) * 100;

    return [
      '<div class="fit-advisor__modal" role="dialog" aria-modal="true">',
      '  <div class="fit-advisor__top">',
      '    <button type="button" data-fit-close aria-label="Close">×</button>',
      '    <button type="button" data-fit-back aria-label="Back" class="' + (state.step === 0 ? "is-hidden" : "") + '">‹</button>',
      '    <div class="fit-advisor__progress"><span style="width:' + progress + '%"></span></div>',
      "  </div>",
      '  <div class="fit-advisor__body">',
      stepHtml(product, state),
      "  </div>",
      "</div>"
    ].join("");
  }

  function removeModal() {
    document.querySelectorAll(".fit-advisor__modal").forEach(function (modal) {
      modal.remove();
    });
  }

  function stepHtml(product, state) {
    var p = state.profile;
    if (state.step === 0) return profileStep(p);
    if (state.step === 1) return sizeStep(p);
    if (state.step === 2) return fitStep(p);
    if (state.step === 3) return bodyStep(p);
    return resultStep(product, p);
  }

  function profileStep(p) {
    return [
      '<form class="fit-advisor__screen" data-fit-form>',
      '  <label><span>FAVORITE SECTION</span>' + picker("section", sectionOptions(), p.section, "Select") + "</label>",
      '  <label><span>DATE OF BIRTH (OPTIONAL)</span>' + picker("birthYear", yearOptions(), p.birthYear, "Select") + "</label>",
      '  <button class="fit-advisor__outline" type="submit">CONTINUE</button>',
      "</form>"
    ].join("");
  }

  function sizeStep(p) {
    var heightSelect = p.heightUnit === "cm"
      ? picker("heightCm", rangeOptions(140, 215), p.heightCm, "180")
      : picker("heightTotal", heightInchOptions(), String(Number(p.heightFeet || 5) * 12 + Number(p.heightInches || 11)), "5' 11\"");
    var weightSelect = p.weightUnit === "kg"
      ? picker("weightKg", rangeOptions(40, 160), p.weightKg, "69")
      : picker("weight", rangeOptions(90, 350), p.weight, "152");

    return [
      '<form class="fit-advisor__screen" data-fit-form>',
      '  <label><span>HOW TALL ARE YOU?</span>' + heightSelect + "</label>",
      '  <div class="fit-advisor__units">',
      unitButton("heightUnit", "cm", "CM", p.heightUnit),
      unitButton("heightUnit", "in", "IN", p.heightUnit),
      "  </div>",
      '  <label><span>HOW MUCH DO YOU WEIGH?</span>' + weightSelect + "</label>",
      '  <div class="fit-advisor__units">',
      unitButton("weightUnit", "kg", "KG", p.weightUnit),
      unitButton("weightUnit", "lb", "LBS", p.weightUnit),
      "  </div>",
      '  <button class="fit-advisor__outline" type="submit">CONTINUE</button>',
      "</form>"
    ].join("");
  }

  function fitStep(p) {
    var value = fitToIndex(p.desiredFit);

    return [
      '<form class="fit-advisor__screen fit-advisor__screen--fit" data-fit-form>',
      "  <p>HOW DO YOU LIKE YOUR CLOTHES TO FIT?</p>",
      '  <div class="fit-advisor__range-wrap" data-fit-value="' + esc(p.desiredFit) + '">',
      '    <input class="fit-advisor__range" type="range" min="0" max="2" step="1" name="fitPosition" value="' + value + '" data-fit-range>',
      '    <div class="fit-advisor__scale-labels">',
      rangeLabel("fitted", "FITTED", p.desiredFit),
      rangeLabel("regular", "REGULAR", p.desiredFit),
      rangeLabel("loose", "LOOSE", p.desiredFit),
      "    </div>",
      "  </div>",
      '  <button class="fit-advisor__outline" type="submit">CONTINUE</button>',
      "</form>"
    ].join("");
  }

  function bodyStep(p) {
    return [
      '<form class="fit-advisor__screen" data-fit-form>',
      '  <div class="fit-advisor__shape">',
      "    <p>ABDOMEN (OPTIONAL)</p>",
      bodyVisual("abdomen", p.abdomen),
      '    <div class="fit-advisor__choices">',
      choice("abdomen", "flat", "FLAT", p.abdomen),
      choice("abdomen", "medium", "MEDIUM", p.abdomen),
      choice("abdomen", "full", "FULL", p.abdomen),
      "    </div>",
      "  </div>",
      '  <div class="fit-advisor__shape">',
      "    <p>CHEST AND SHOULDERS (OPTIONAL)</p>",
      bodyVisual("chest", p.chestShape),
      '    <div class="fit-advisor__choices">',
      choice("chestShape", "narrow", "NARROW", p.chestShape),
      choice("chestShape", "medium", "MEDIUM", p.chestShape),
      choice("chestShape", "wide", "WIDE", p.chestShape),
      "    </div>",
      "  </div>",
      '  <button class="fit-advisor__outline" type="submit">SEE RECOMMENDATION</button>',
      "</form>"
    ].join("");
  }

  function bodyVisual(type, value) {
    if (type === "abdomen") {
      var abdomenPath = value === "flat"
        ? "M112 52 C113 78 112 100 110 124"
        : value === "full"
          ? "M110 52 C132 75 132 103 111 124"
          : "M111 52 C123 75 122 101 111 124";

      return [
        '<svg class="fit-advisor__body-visual" viewBox="0 0 160 150" aria-hidden="true">',
        '  <path d="M70 12 C58 34 57 54 63 76 C70 99 66 117 60 136" />',
        '  <path d="M94 12 C87 28 87 44 94 58 C101 74 102 96 98 136" />',
        '  <path d="M79 54 C79 82 82 106 88 136" />',
        '  <path class="fit-advisor__highlight" d="' + abdomenPath + '" />',
        "</svg>"
      ].join("");
    }

    var left = value === "narrow" ? "M48 58 C39 82 36 108 34 134" : value === "wide" ? "M32 54 C22 84 22 111 27 136" : "M40 56 C31 84 30 111 32 136";
    var right = value === "narrow" ? "M112 58 C121 82 124 108 126 134" : value === "wide" ? "M128 54 C138 84 138 111 133 136" : "M120 56 C129 84 130 111 128 136";

    return [
      '<svg class="fit-advisor__body-visual fit-advisor__body-visual--chest" viewBox="0 0 160 150" aria-hidden="true">',
      '  <path d="M68 18 C70 30 75 36 80 36 C85 36 90 30 92 18" />',
      '  <path d="M68 34 C50 42 42 48 36 66 C31 85 28 108 24 136" />',
      '  <path d="M92 34 C110 42 118 48 124 66 C129 85 132 108 136 136" />',
      '  <path d="M55 64 C67 76 92 76 105 64" />',
      '  <path d="M62 70 C60 93 58 116 56 138" />',
      '  <path d="M98 70 C100 93 102 116 104 138" />',
      '  <path class="fit-advisor__highlight" d="' + left + '" />',
      '  <path class="fit-advisor__highlight" d="' + right + '" />',
      "</svg>"
    ].join("");
  }

  function resultStep(product, profile) {
    var rec = recommend(product.chart, profile);
    var productMedia = product.image
      ? '<img class="fit-advisor__product-image" src="' + esc(product.image) + '" alt="' + esc(product.title) + '">'
      : '<div class="fit-advisor__shirt" aria-hidden="true"></div>';

    return [
      '<div class="fit-advisor__screen fit-advisor__screen--result">',
      productMedia,
      '  <p class="fit-advisor__size">SIZE ' + esc(rec.size) + "</p>",
      '  <button class="fit-advisor__outline" type="button" data-fit-add="' + esc(rec.size) + '">ADD SIZE ' + esc(rec.size) + "</button>",
      '  <button class="fit-advisor__link" type="button" data-fit-edit>Edit</button>',
      '  <button class="fit-advisor__link" type="button" data-fit-clear>Clear saved size</button>',
      "</div>"
    ].join("");
  }

  function bind(mount, product, state, render) {
    var modal = document.querySelector(".fit-advisor__modal");
    var root = modal || mount;

    mount.querySelector("[data-fit-open]")?.addEventListener("click", function () {
      state.open = true;
      state.step = 0;
      state.profile = normalizeProfile(null);
      render();
    });

    root.querySelector("[data-fit-close]")?.addEventListener("click", function () {
      state.open = false;
      render();
    });

    root.querySelector("[data-fit-back]")?.addEventListener("click", function () {
      syncForm(root, state.profile);
      state.step = Math.max(0, state.step - 1);
      render();
    });

    root.querySelectorAll("[data-fit-unit]").forEach(function (button) {
      button.addEventListener("click", function () {
        syncForm(root, state.profile);
        changeUnit(state.profile, button.dataset.fitUnit, button.dataset.value);
        render();
      });
    });

    root.querySelectorAll("[data-fit-picker-toggle]").forEach(function (button) {
      button.addEventListener("click", function () {
        var picker = button.closest("[data-fit-picker]");
        var isOpen = picker.classList.contains("is-open");
        root.querySelectorAll("[data-fit-picker]").forEach(function (item) {
          item.classList.remove("is-open");
        });
        picker.classList.toggle("is-open", !isOpen);
      });
    });

    root.querySelectorAll("[data-fit-picker-option]").forEach(function (button) {
      button.addEventListener("click", function () {
        var picker = button.closest("[data-fit-picker]");
        var input = picker.querySelector("input[type='hidden']");
        var toggle = picker.querySelector("[data-fit-picker-toggle]");
        var value = button.dataset.value;

        input.value = value;
        toggle.textContent = button.textContent;
        state.profile[input.name] = value;
        picker.classList.remove("is-open");

        picker.querySelectorAll("[data-fit-picker-option]").forEach(function (optionButton) {
          optionButton.classList.toggle("is-active", optionButton === button);
        });
      });
    });

    var range = root.querySelector("[data-fit-range]");
    if (range) {
      range.addEventListener("input", function () {
        state.profile.desiredFit = indexToFit(range.value);
        updateFitRange(range);
      });
      range.addEventListener("change", function () {
        state.profile.desiredFit = indexToFit(range.value);
        updateFitRange(range);
      });
    }

    root.querySelectorAll("[data-fit-choice]").forEach(function (button) {
      button.addEventListener("click", function () {
        state.profile[button.dataset.fitChoice] = button.dataset.value;
        mapBody(state.profile);
        render();
      });
    });

    var form = root.querySelector("[data-fit-form]");
    form?.addEventListener("submit", function (event) {
      event.preventDefault();
      syncForm(root, state.profile);
      mapBody(state.profile);

      if (state.step === RESULT_STEP - 1) {
        var recommendation = recommend(product.chart, state.profile);
        saveLastRecommendedSize(product, recommendation.size);
        selectSize(recommendation.size);
      }

      state.step += 1;
      render();
    });

    root.querySelector("[data-fit-edit]")?.addEventListener("click", function () {
      state.step = 0;
      render();
    });

    root.querySelector("[data-fit-clear]")?.addEventListener("click", function () {
      clearLastRecommendedSize(product);
      state.profile = normalizeProfile(null);
      state.step = 0;
      render();
    });

    root.querySelector("[data-fit-add]")?.addEventListener("click", function (event) {
      var size = event.currentTarget.dataset.fitAdd;
      saveLastRecommendedSize(product, size);
      selectSize(size);
      state.open = false;
      render();
    });
  }

  function syncForm(mount, profile) {
    var form = mount.querySelector("[data-fit-form]");
    if (!form) return;

    new FormData(form).forEach(function (value, key) {
      profile[key] = String(value);
    });

    if (profile.heightTotal) {
      var totalHeight = Number(profile.heightTotal);
      profile.heightFeet = String(Math.floor(totalHeight / 12));
      profile.heightInches = String(totalHeight % 12);
    }

    if (profile.fitPosition !== undefined) profile.desiredFit = indexToFit(profile.fitPosition);

    if (profile.heightUnit === "cm") setImperialHeight(profile);
    if (profile.heightUnit === "in") setMetricHeight(profile);
    if (profile.weightUnit === "kg") profile.weight = String(Math.round(Number(profile.weightKg || 69) * 2.20462));
    if (profile.weightUnit === "lb") profile.weightKg = String(Math.round(Number(profile.weight || 152) / 2.20462));
  }

  // ----- Fit Advisor recommendation engine (rewritten) -----
  //
  // Chart chest values are GARMENT pit-to-pit HALF measurements, doubled in
  // normalizeRange() to a full garment circumference. We estimate the user's
  // BODY chest, then pick the size whose intended body chest (garment circ
  // minus the fit-style ease) is closest, using height only as a gentle
  // tie-breaker / sanity check.

  var GARMENT_EASE = { fitted: 3, regular: 5, loose: 7 };

  function recommend(chart, profile) {
    var p = normalizeProfile(profile);
    var height = Number(p.heightFeet) * 12 + Number(p.heightInches);
    var weight = Number(p.weight);

    var directChest = measurementToInches(p.chestMeasurement, p.measurementUnit);
    var bodyChest = directChest || estimateBodyChest(height, weight, p);

    var ease = GARMENT_EASE[p.desiredFit];
    if (ease == null) ease = GARMENT_EASE.regular;

    var chartHasHeight = chart.some(function (s) { return !!s.height; });

    var scored = chart.map(function (size, index) {
      var cost = 0;
      var hasSignal = false;

      // Primary signal: garment chest fit.
      if (size.chest) {
        var garmentCirc = (size.chest[0] + size.chest[1]) / 2; // full circumference
        var intendedBody = garmentCirc - ease;
        cost += Math.abs(intendedBody - bodyChest);
        hasSignal = true;
      }

      // Secondary: distance OUTSIDE the size's height band (0 if inside).
      if (chartHasHeight && size.height) {
        var hPen = 0;
        if (height < size.height[0]) hPen = size.height[0] - height;
        else if (height > size.height[1]) hPen = height - size.height[1];
        cost += hPen * 0.18;
        hasSignal = true;
      }

      // Fallback if a chart has neither chest nor height: use length vs height.
      if (!hasSignal && size.length) {
        var targetLength = height * 0.402;
        var lc = (size.length[0] + size.length[1]) / 2;
        cost += Math.abs(lc - targetLength);
      }

      return { index: index, size: size.size, cost: cost };
    });

    scored.sort(function (a, b) {
      if (a.cost !== b.cost) return a.cost - b.cost;
      return a.index - b.index; // stable: prefer the earlier (smaller) size on ties
    });

    var winner = scored[0];
    return chart[winner ? winner.index : 0] || chart[0] || { size: "M" };
  }

  // Body chest (inches) estimated from height(in), weight(lb) and shape.
  // Coefficients fitted to standard male anthropometric anchors.
  function estimateBodyChest(height, weight, profile) {
    var chest = 0.1249 * weight - 0.0919 * height + 24.96;
    if (profile.chestShape === "wide") chest += 1.5;
    if (profile.chestShape === "narrow") chest -= 1.5;
    if (profile.abdomen === "full") chest += 1.0;
    if (profile.abdomen === "flat") chest -= 0.6;
    return chest;
  }

  function fitAdjustment(profile) {
    if (profile.desiredFit === "fitted") return -1;
    if (profile.desiredFit === "loose") return 1;
    return 0;
  }

  function buildAdjustment(profile, height, weight) {
    var bmi = (weight / Math.max(height * height, 1)) * 703;
    var score = 0;

    if (bmi >= 29) score += 1;
    else if (bmi <= 19.5) score -= 1;

    if (profile.abdomen === "full") score += 1;
    if (profile.abdomen === "flat" && profile.chestShape === "narrow") score -= 1;
    if (profile.chestShape === "wide") score += 1;
    if (profile.chestShape === "narrow") score -= 1;

    return clamp(score, -1, 1);
  }

  function estimateBodyWaist(height, weight) {
    return 0.20 * weight + 0.045 * height;
  }

  function estimateShoulder(height, weight) {
    return height * 0.255 + (weight - 160) * 0.01;
  }

  function measurementToInches(value, unit) {
    if (value === undefined || value === null || value === "") return null;

    var number = Number(value);
    if (!Number.isFinite(number) || number <= 0) return null;
    return unit === "cm" ? number / 2.54 : number;
  }

  function rangeScore(value, range, penaltyPerInch) {
    if (!range) return 70;
    var min = range[0];
    var max = range[1];
    var penalty = penaltyPerInch || 10;
    if (value >= min && value <= max) return 100;
    return Math.max(0, 100 - Math.min(Math.abs(value - min), Math.abs(value - max)) * penalty);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function selectSize(size) {
    var normalized = String(size).toUpperCase();
    var targets = Array.from(document.querySelectorAll("input[type='radio'], button, label, [role='button']"));

    var target = targets.find(function (el) {
      var text = el.value || el.getAttribute("aria-label") || el.textContent || "";
      return text.trim().toUpperCase() === normalized;
    });

    if (!target) return;

    if (target.matches("input[type='radio']")) {
      target.checked = true;
      target.dispatchEvent(new Event("change", { bubbles: true }));
    } else {
      var input = target.querySelector("input[type='radio']");
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
      target.click();
    }
  }

  function findProductImage(productRoot) {
    var selectors = [
      "media-gallery .product-media__image",
      "media-gallery img",
      ".product-media__image",
      ".product__media img",
      "img[src*='/products/']"
    ];

    var scope = productRoot && productRoot !== document.body ? productRoot : document;
    for (var i = 0; i < selectors.length; i += 1) {
      var image = scope.querySelector(selectors[i]) || document.querySelector(selectors[i]);
      var src = image && (image.currentSrc || image.src || image.getAttribute("src"));
      if (src) return src;
    }

    return "";
  }

  function selectLastRecommendedSize(product) {
    var saved = readLastRecommendedSize(product);
    if (!saved) return;

    window.setTimeout(function () {
      selectSize(saved);
    }, 150);
  }

  function readLastRecommendedSize(product) {
    try {
      var stored = JSON.parse(localStorage.getItem(SIZE_KEY) || "{}");
      return stored[productKey(product)] || stored.global || "";
    } catch (error) {
      return "";
    }
  }

  function saveLastRecommendedSize(product, size) {
    if (!size) return;

    try {
      var stored = JSON.parse(localStorage.getItem(SIZE_KEY) || "{}");
      stored[productKey(product)] = String(size).toUpperCase();
      stored.global = String(size).toUpperCase();
      localStorage.setItem(SIZE_KEY, JSON.stringify(stored));
    } catch (error) {
      localStorage.setItem(SIZE_KEY, JSON.stringify({ global: String(size).toUpperCase() }));
    }
  }

  function clearLastRecommendedSize(product) {
    try {
      var stored = JSON.parse(localStorage.getItem(SIZE_KEY) || "{}");
      delete stored[productKey(product)];
      delete stored.global;
      localStorage.setItem(SIZE_KEY, JSON.stringify(stored));
    } catch (error) {
      localStorage.removeItem(SIZE_KEY);
    }
  }

  function productKey(product) {
    return product && product.id ? String(product.id) : window.location.pathname;
  }

  function moveIntoSizing(mount) {
    var sizing = findSizingArea();
    if (!sizing || sizing.contains(mount)) return;

    var target =
      sizing.querySelector("[class*='accordion'][class*='content']") ||
      sizing.querySelector("[class*='content']") ||
      sizing.querySelector(".rte")?.parentElement ||
      sizing;

    target.appendChild(mount);
  }

  function findSizingArea() {
    var items = Array.from(document.querySelectorAll("summary, button, h2, h3, h4, [role='button'], [class*='accordion']"));
    var heading = items.find(function (el) {
      return (el.textContent || "").trim().toUpperCase() === "SIZING";
    });

    if (!heading) return null;
    return heading.closest("details") || heading.closest("[class*='accordion']") || heading.parentElement;
  }

  function retryMove(mount) {
    var count = 0;
    var timer = window.setInterval(function () {
      count += 1;
      moveIntoSizing(mount);
      if (count >= 30) window.clearInterval(timer);
    }, 250);
  }

  function normalizeProfile(profile) {
    var p = Object.assign({
      section: "Man",
      birthYear: "",
      heightUnit: "cm",
      heightCm: "180",
      heightFeet: "5",
      heightInches: "11",
      weightUnit: "kg",
      weightKg: "69",
      weight: "152",
      measurementUnit: "in",
      chestMeasurement: "",
      shoulderMeasurement: "",
      desiredFit: "regular",
      abdomen: "medium",
      chestShape: "medium",
      bodyType: "average",
      topStructure: "balanced"
    }, profile || {});

    mapBody(p);
    return p;
  }

  function mapBody(p) {
    if (p.abdomen === "full") p.bodyType = "full";
    else if (p.chestShape === "wide" && p.abdomen === "flat") p.bodyType = "athletic";
    else if (p.chestShape === "wide") p.bodyType = "broad";
    else if (p.chestShape === "narrow" && p.abdomen === "flat") p.bodyType = "lean";
    else p.bodyType = "average";

    p.topStructure = p.chestShape === "wide" ? "broad" : p.chestShape === "narrow" ? "narrow" : "balanced";
  }

  function changeUnit(profile, key, value) {
    var previous = profile[key];
    if (previous === value) return;

    profile[key] = value;
    if (key === "heightUnit" && value === "cm") setMetricHeight(profile);
    if (key === "heightUnit" && value === "in") setImperialHeight(profile);
    if (key === "weightUnit" && value === "kg") profile.weightKg = String(Math.round(Number(profile.weight || 152) / 2.20462));
    if (key === "weightUnit" && value === "lb") profile.weight = String(Math.round(Number(profile.weightKg || 69) * 2.20462));
    if (key === "measurementUnit") convertMeasurementUnit(profile, value);
  }

  function setMetricHeight(p) {
    var inches = Number(p.heightFeet || 5) * 12 + Number(p.heightInches || 11);
    p.heightCm = String(Math.round(inches * 2.54));
  }

  function setImperialHeight(p) {
    var inches = Math.round(Number(p.heightCm || 180) / 2.54);
    p.heightFeet = String(Math.floor(inches / 12));
    p.heightInches = String(inches % 12);
  }

  function convertMeasurementUnit(profile, unit) {
    ["chestMeasurement", "shoulderMeasurement"].forEach(function (key) {
      if (!profile[key]) return;

      var number = Number(profile[key]);
      if (!Number.isFinite(number)) return;

      profile[key] = unit === "cm"
        ? String(Math.round(number * 2.54))
        : String(Math.round(number / 2.54));
    });
  }

  function clearOldProfile() {
    try {
      localStorage.removeItem(OLD_PROFILE_KEY);
    } catch (error) {
      // Ignore private-mode storage errors.
    }
  }

  function picker(name, options, current, placeholder) {
    var currentValue = current === undefined || current === null ? "" : String(current);
    var selected = options.find(function (item) {
      return String(item.value) === currentValue;
    });
    var buttonLabel = selected ? selected.label : placeholder;

    return [
      '<div class="fit-advisor__picker" data-fit-picker>',
      '  <input type="hidden" name="' + esc(name) + '" value="' + esc(currentValue) + '">',
      '  <button class="fit-advisor__picker-toggle" type="button" data-fit-picker-toggle>' + esc(buttonLabel || "Select") + "</button>",
      '  <div class="fit-advisor__picker-menu" data-fit-picker-menu>',
      options.map(function (item) {
        var value = String(item.value);
        return '<button type="button" data-fit-picker-option data-value="' + esc(value) + '" class="' + (value === currentValue ? "is-active" : "") + '">' + esc(item.label) + "</button>";
      }).join(""),
      "  </div>",
      "</div>"
    ].join("");
  }

  function sectionOptions() {
    return [
      { value: "Man", label: "Man" },
      { value: "Woman", label: "Woman" },
      { value: "Unisex", label: "Unisex" }
    ];
  }

  function yearOptions() {
    var options = [{ value: "", label: "Select" }];
    for (var y = new Date().getFullYear() - 13; y >= 1940; y -= 1) {
      options.push({ value: String(y), label: String(y) });
    }
    return options;
  }

  function rangeOptions(start, end) {
    var options = [];
    for (var i = start; i <= end; i += 1) {
      options.push({ value: String(i), label: String(i) });
    }
    return options;
  }

  function heightInchOptions() {
    var options = [];
    for (var i = 56; i <= 82; i += 1) {
      options.push({
        value: String(i),
        label: Math.floor(i / 12) + "' " + (i % 12) + '"'
      });
    }
    return options;
  }

  function option(value, current) {
    return '<option value="' + esc(value) + '"' + (String(value) === String(current) ? " selected" : "") + ">" + esc(value) + "</option>";
  }

  function years(current) {
    var html = "";
    for (var y = new Date().getFullYear() - 13; y >= 1940; y -= 1) html += option(y, current);
    return html;
  }

  function selectRange(name, start, end, current) {
    var html = '<select name="' + name + '">';
    for (var i = start; i <= end; i += 1) html += option(i, current);
    return html + "</select>";
  }

  function selectHeightInches(p) {
    var current = Number(p.heightFeet || 5) * 12 + Number(p.heightInches || 11);
    var html = '<select name="heightTotal">';
    for (var i = 56; i <= 82; i += 1) {
      var label = Math.floor(i / 12) + "' " + (i % 12) + '"';
      html += '<option value="' + i + '"' + (i === current ? " selected" : "") + ">" + label + "</option>";
    }
    return html + "</select>";
  }

  function unitButton(key, value, label, current) {
    return '<button type="button" data-fit-unit="' + key + '" data-value="' + value + '" class="' + (current === value ? "is-active" : "") + '">' + label + "</button>";
  }

  function rangeLabel(value, label, current) {
    return '<button type="button" data-fit-choice="desiredFit" data-value="' + value + '" class="' + (current === value ? "is-active" : "") + '">' + label + "</button>";
  }

  function choice(key, value, label, current) {
    return '<button type="button" data-fit-choice="' + key + '" data-value="' + value + '" class="' + (current === value ? "is-active" : "") + '">' + label + "</button>";
  }

  function fitToIndex(value) {
    if (value === "fitted") return 0;
    if (value === "loose") return 2;
    return 1;
  }

  function indexToFit(value) {
    var number = Number(value);
    if (number <= 0) return "fitted";
    if (number >= 2) return "loose";
    return "regular";
  }

  function updateFitRange(range) {
    var value = indexToFit(range.value);
    var wrap = range.closest(".fit-advisor__range-wrap");
    if (!wrap) return;

    wrap.dataset.fitValue = value;
    wrap.querySelectorAll("[data-fit-choice='desiredFit']").forEach(function (button) {
      button.classList.toggle("is-active", button.dataset.value === value);
    });
  }

  function esc(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[char];
    });
  }

  function injectStyles() {
    if (document.querySelector("#rawfella-fit-advisor-style")) return;

    var style = document.createElement("style");
    style.id = "rawfella-fit-advisor-style";
    style.textContent = [
      "body.fit-advisor-modal-open{overflow:hidden}",
      ".fit-advisor__launcher{display:flex;align-items:center;justify-content:space-between;gap:16px;border:0;margin-top:18px;padding:14px 0}",
      ".fit-advisor__eyebrow{color:#000!important;font-weight:700;font-size:.95rem;letter-spacing:0;margin:0;text-transform:uppercase}",
      ".fit-advisor__launcher button,.fit-advisor__outline{background:#fff;border:1px solid #111;border-radius:0;color:#111;cursor:pointer;font:inherit;font-weight:700;min-height:48px;min-width:160px;padding:0 22px;text-transform:uppercase}",
      ".fit-advisor__modal,.fit-advisor__modal *{box-sizing:border-box}",
      ".fit-advisor__modal{position:fixed!important;inset:0!important;z-index:2147483647!important;background:#fff!important;color:#111;font-family:Arial,Helvetica,sans-serif;display:flex;flex-direction:column;isolation:isolate;pointer-events:auto}",
      ".fit-advisor__top{position:sticky;top:0;z-index:4;display:grid;grid-template-columns:48px 48px 1fr;align-items:center;min-height:76px;padding:16px 24px 0;background:#fff}",
      ".fit-advisor__top button{background:transparent!important;border:0!important;box-shadow:none!important;color:#444!important;cursor:pointer;font:inherit;font-size:34px;height:48px;line-height:1;padding:0;width:48px;z-index:5}.fit-advisor__top .is-hidden{visibility:hidden;pointer-events:none}",
      ".fit-advisor__progress{justify-self:center;background:#ddd;height:2px;width:160px}.fit-advisor__progress span{display:block;background:#111;height:100%}",
      ".fit-advisor__body{display:flex;flex:1;min-height:0}.fit-advisor__screen{display:grid;flex:1;gap:48px;justify-items:center;align-content:center;overflow:auto;padding:28px 24px 42px;min-height:calc(100dvh - 76px)}",
      ".fit-advisor__screen label{display:grid;gap:16px;justify-items:center}.fit-advisor__screen label span,.fit-advisor__screen p{text-align:center;text-transform:uppercase;color:#444;font-weight:500;margin:0}",
      ".fit-advisor__screen select{appearance:none;background:#fff;border:0;color:#333;font:inherit;font-size:18px;min-height:36px;text-align:center;text-align-last:center}",
      ".fit-advisor__picker{display:grid;justify-items:center;position:relative;width:min(900px,calc(100vw - 56px))}.fit-advisor__picker-toggle{position:relative;background:transparent!important;border:0!important;box-shadow:none!important;color:#333!important;cursor:pointer;font:inherit;font-size:18px;min-height:36px;min-width:92px;padding:0 24px 0 12px;text-align:center}.fit-advisor__picker-toggle:after{content:'';position:absolute;right:6px;top:50%;width:8px;height:8px;border-right:1px solid #333;border-bottom:1px solid #333;transform:translateY(-65%) rotate(45deg)}.fit-advisor__picker.is-open .fit-advisor__picker-toggle:after{transform:translateY(-25%) rotate(225deg)}",
      ".fit-advisor__picker-menu{display:none;background:#fff;border:1px solid #555;margin-top:8px;max-height:288px;overflow-y:auto;overscroll-behavior:contain;padding:16px 0;width:100%;z-index:3}.fit-advisor__picker.is-open .fit-advisor__picker-menu{display:block}.fit-advisor__picker-menu button{background:transparent!important;border:0!important;box-shadow:none!important;color:#444!important;cursor:pointer;display:block;font:inherit;font-size:18px;line-height:1.2;min-height:44px;padding:12px 20px;text-align:center;width:100%}.fit-advisor__picker-menu button.is-active{background:#f3f3f3!important;color:#111!important;font-weight:500}.fit-advisor__picker-menu button:hover{background:#f7f7f7!important}",
      ".fit-advisor__units,.fit-advisor__choices{display:flex;gap:28px;justify-content:center}.fit-advisor__units button,.fit-advisor__choices button,.fit-advisor__scale-labels button,.fit-advisor__link{background:transparent!important;border:0!important;color:#444;cursor:pointer;font:inherit;text-transform:uppercase}.fit-advisor__units .is-active,.fit-advisor__choices .is-active,.fit-advisor__scale-labels .is-active{color:#111;font-weight:800}",
      ".fit-advisor__range-wrap{display:grid;gap:26px;width:min(980px,calc(100vw - 56px))}.fit-advisor__range{appearance:none;-webkit-appearance:none;background:transparent;cursor:pointer;height:44px;width:100%;touch-action:pan-y}.fit-advisor__range::-webkit-slider-runnable-track{height:2px;background:#111}.fit-advisor__range::-moz-range-track{height:2px;background:#111}.fit-advisor__range::-webkit-slider-thumb{-webkit-appearance:none;width:28px;height:28px;border:0;border-radius:50%;background:#000;margin-top:-13px}.fit-advisor__range::-moz-range-thumb{width:28px;height:28px;border:0;border-radius:50%;background:#000}",
      ".fit-advisor__scale-labels{display:grid;grid-template-columns:repeat(3,1fr);align-items:start}.fit-advisor__scale-labels button:first-child{text-align:left}.fit-advisor__scale-labels button:nth-child(2){text-align:center}.fit-advisor__scale-labels button:last-child{text-align:right}",
      ".fit-advisor__shape{display:grid;justify-items:center;gap:18px}.fit-advisor__body-visual{width:130px;height:130px;display:block}.fit-advisor__body-visual path{fill:none;stroke:#111;stroke-width:4;stroke-linecap:round;stroke-linejoin:round}.fit-advisor__body-visual .fit-advisor__highlight{stroke:#2f7cff;stroke-width:4}.fit-advisor__body-visual--chest{width:170px;height:140px}",
      ".fit-advisor__screen--result{gap:22px;text-align:center}.fit-advisor__product-image{display:block;width:min(260px,64vw);max-height:320px;object-fit:contain}.fit-advisor__shirt{width:170px;height:170px;background:#111;clip-path:polygon(36% 12%,45% 5%,55% 5%,64% 12%,86% 27%,76% 48%,66% 42%,66% 84%,34% 84%,34% 42%,24% 48%,14% 27%)}.fit-advisor__size{font-size:16px}.fit-advisor__link{text-decoration:underline;text-transform:none}",
      "@media(max-width:720px){.fit-advisor__launcher{align-items:stretch}.fit-advisor__launcher button{min-width:140px}.fit-advisor__progress{width:128px}.fit-advisor__top{grid-template-columns:44px 44px 1fr;padding-inline:12px}.fit-advisor__screen{gap:38px;padding-inline:18px}.fit-advisor__range-wrap,.fit-advisor__picker{width:calc(100vw - 36px)}.fit-advisor__picker-menu{max-height:250px}}"
    ].join("");
    document.head.appendChild(style);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();